// extracted by mini-css-extract-plugin
module.exports = {"Training":"Training_Training__1ELR_","Singular":"Training_Singular__BAwkh","ListItem":"Training_ListItem__t5ZLf","Wrap":"Training_Wrap__3etuA","List":"Training_List__1wO9C"};